import { encode } from 'base64-arraybuffer';

export async function downloadImageFromUrl(imageUrl: string) {
  fetch(imageUrl, {
    method: 'GET',
    headers: {
      pragma: 'no-cache',
      'cache-control': 'no-cache',
    },
  })
    .then((response) => {
      response.arrayBuffer().then((buffer) => {
        const url = window.URL.createObjectURL(new Blob([buffer]));
        const link = document.createElement('a');
        link.href = url;
        link.download = 'image.jpg';
        document.body.appendChild(link);
        link.click();
      });
    })
    .catch((err) => {
      console.log(err);
    });
}

const PDFMAKE_SUPPORTED_MIMES = ['image/png', 'image/jpeg'];

// TODO: confirmar com backend se ainda existem respostas legadas em base64.
// Se backend só retornar URL agora, remover este short-circuit e simplificar a função.
export async function getBase64FromImageUrl(imageUrl: string) {
  if (imageUrl?.startsWith('data:')) return imageUrl;

  try {
    const response = await fetch(imageUrl, {
      method: 'GET',
      headers: {
        pragma: 'no-cache',
        'cache-control': 'no-cache',
      },
    });

    if (!response.ok) return '';

    const imageBuffer = await response.arrayBuffer();
    if (imageBuffer.byteLength === 0) return '';

    const contentType = response.headers.get('content-type')?.split(';')[0].trim() ?? '';
    const mime = PDFMAKE_SUPPORTED_MIMES.includes(contentType) ? contentType : 'image/png';

    const base64String = encode(imageBuffer);
    return `data:${mime};base64,${base64String}`;
  } catch {
    return '';
  }
}

export function getImageDimensions(
  src: string,
): Promise<{ width: number; height: number }> {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => resolve({ width: img.naturalWidth, height: img.naturalHeight });
    img.onerror = () => resolve({ width: 1, height: 1 });
    img.src = src;
  });
}
